import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import TwinTable from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderBoolean, CustomRenderString, EditRowNotLink } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import ModalCEProductType from './ModalCEProductType'
import { ProductTypeModelType } from '@teinor/erp/types/company/product/productType'
import { getISOCurrencyMain } from '../../../../../../utils/reducers/getters'
import { useMemo } from 'react'
import DisplayPrice from '../../../../../../baseComponents/Displays/DisplayPrice'
import { totalCalculateParams } from '@teinor/erp/prices/quote/calculate'

interface ProductTypesProps extends ComponentWithPermissions { }

const ProductTypes: React.FC<ProductTypesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('productTypes', 'Tipos de producto'),
        newText: t('newProductType', 'Nuevo tipo de producto')
    }

    return (
        <BaseScreenTable TableComponent={TableProductTypes} CreateModalComponent={ModalCEProductType} EditModalComponent={ModalCEProductType} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableProductTypesProps extends TableComponentProps { }

const TableProductTypes: React.FC<TableProductTypesProps> = ({setTableInstance, setOpened }) => {
    const { t } = useTwinTranslation()
    const CurrencyId = useMemo(() => getISOCurrencyMain(), [])
    const columns: ColumnTableSchema<ProductTypeModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            width: 75
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            },
        },
        {
            id: 'divideTotals',
            dataKey: 'divideTotals',
            label: t('divideTotalsOrder', 'Dividir totales en pedidos'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
        },
        {
            id: 'price',
            dataKey: 'price',
            label: t('price', 'Precio'),
            customRender: (parameterValue) => parameterValue ? <DisplayPrice value={parseFloat(parameterValue)} CurrencyId={CurrencyId} with_vat={false} calculateParams={totalCalculateParams} /> : <span></span>,
        },
        {
            id: 'wasteWeight',
            dataKey: 'wasteWeight',
            label: t('wasteWeight', 'Merma'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue ? (parameterValue+'%') : ''} /> ,
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />
        },
    ]
    return (
        <TwinTable  columns={columns} name='productTypes' getDataFrom='/api/app/product/productType/getAllProductTypes' setTableInstance={setTableInstance} />
    )
}

export default ProductTypes